import { Link, useNavigate } from "react-router-dom";
import { Globals } from "../../global/Globals";
import CryptoUtils from "../../util/cryptoUtils";
export default function FaqNav({props}){
    const navigate = useNavigate();
    const roleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
    const {FirstNavbar,SecondNavbar,Title, ParentTab}=props
    const clickNav = () => {
        const dashboardTab =
        roleId === "5" ? "dashboard" :
        (roleId === "1" && FirstNavbar === "Dashboard") ? "dashboard" :
        roleId === "1" ? "admin" :
        roleId === "2" || roleId === "3" || roleId === "4" ? "internal_dashboard" :
        "dashboard";

        const proposalsTab =
        roleId === "5" ? "proposals" :
        roleId === "1" ? "internal_management" :
        roleId === "2" || roleId === "3" || roleId === "4" ? "all_proposals" :
        "";

        const otherTabs = 
        (roleId === "1" && ParentTab === "auditTrails") ? "auditTrails"  :
         (roleId === "2" && ParentTab === "requests") ? "requests" :
         (roleId === "2" && ParentTab === "auditTrails") ? "auditTrails"  :
        "";

        if(FirstNavbar === "Dashboard" && ParentTab != 'admin') {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: `${dashboardTab}` } });
        } else if(FirstNavbar === "Dashboard" && ParentTab === 'admin') {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: `${ParentTab}` } });
        }else if(FirstNavbar === "Requests") {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: `${otherTabs}` } });
        } else if(FirstNavbar === "Audit Trails") {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: `${otherTabs}` } });
        } else {
            navigate(Globals.NAVPATH.HOME, { state: { activeHeader: `${proposalsTab}` } });
        }
    }

    return (
        <div className="breadcrumbs">
            {/* <div className="FaqNav">
                <div className="Navbar">
                    <p className="breadcrumbs-Header" onClick={clickNav}>{FirstNavbar} </p>
                    <p className="breadcrumbs-Header">&gt;</p>
                    <p className="breadcrumbs-Header">{SecondNavbar} </p>
                </div>
            </div> */}

            <div className="FAQHeader"> <strong>{Title}</strong></div>
        </div>
    )
}